import type { ClientConfig } from "../shared";

export const clientConfig: ClientConfig = (window as unknown as { readonly ClientConfig: ClientConfig }).ClientConfig;
